module.exports = __webpack_public_path__ + "media/svg/DonwloadRedacao-663c928c.svg";